import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogOverViewComponent } from '../components/dialog-over-view/dialog-over-view.component';

export interface DialogData {
  title: string;
  message: string;
  forConfirmation: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(public dialog: MatDialog) {}

  /**
   * Opens a simple dialog with a simple OK button, to inform the user something happened
   * @param dialogTitle title of the dialog
   * @param dialogMessage message to show in the dialog
   * @param dialogWidth width of the dialog, eg:'250px'
   */
  openDialog( dialogTitle: string, dialogMessage: string, dialogWidth: string ): void {
    this.dialog.open(DialogOverViewComponent, {
      width: dialogWidth,
      data: {title: dialogTitle, message: dialogMessage}
    });
  }

  /**
   * Opens a simple dialog with a simple OK button, to inform the user something happened
   * @param dialogTitle title of the dialog
   * @param dialogMessage message to show in the dialog
   * @param dialogWidth width of the dialog, eg:'250px'
   */
   confirmDialog( dialogTitle: string, dialogMessage: string, dialogWidth: string ): MatDialogRef<DialogOverViewComponent, any> {
    return this.dialog.open(DialogOverViewComponent, {
      width: dialogWidth,
      data: {title: dialogTitle, message: dialogMessage, forConfirmation: true}
    });
  }
}
